// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AbDo","field":"styles_field__1sop0","fieldCol":"styles_fieldCol__1tnqU","diffCol":"styles_diffCol__3jm7y","diff":"styles_diff__22nDU"};